import { Controller } from '@hotwired/stimulus';
import { cartCountStore } from '@site-module/store/cart';
import { useStore } from '@shared/script/store';
import type { StoreController } from '@store/types/storeController';

export default class ExternalCartController extends Controller<HTMLElement> implements StoreController {
    static stores = [cartCountStore];

    declare onCartCountUpdateValue: (count: number) => void;

    connect(): void {
        useStore(this);
    }

    /**
     * Uses data-count rather than Stimulus conventions to bridge backwards compatibility.
     */
    onCartCountUpdate(count: number): void {
        this.element.setAttribute('data-count', count.toString());
    }
}
